import { FILTER_DATA } from '@constants/filter';
import { ALIAS, SERVICE_ALIAS, SEARCH_PARAMS } from '@constants/index';
import type { l10nFilterType } from '@type/index';

/*
  "서버 전체"일 때, world별 jobId&jobName 동일한 데이터 추출하여 한개만 보유
  - jobId&jobName 동일한 데이터는 world값 빈값으로 변경
  - jobId&jobName 다른 데이터는 world값 그대로 전달
*/
export const getAllWorldClassNameMap = (classData: { [key: string]: any }[]) => {
  if (!Array.isArray(classData) || classData.length === 0) {
    return [];
  }

  const copyClassNameMap = [...classData];
  const sortClassNameMap = copyClassNameMap.sort((a, b) => a.jobId - b.jobId);
  let newClassData = [] as l10nFilterType;

  sortClassNameMap.reduce((prev, cur, curIdx) => {
    let clonePrev = { ...prev };
    let cloneCur = { ...cur };

    if (clonePrev.jobId === cloneCur.jobId && clonePrev.jobName === cloneCur.jobName) {
      cloneCur.world = '';
    } else {
      clonePrev.world = clonePrev.world.toLowerCase();
      newClassData.push(clonePrev);
    }

    if (curIdx === sortClassNameMap.length - 1) {
      cloneCur.world = cloneCur.world.toLowerCase();
      newClassData.push(cloneCur);
    }

    return cloneCur;
  });

  return newClassData;
};

// 서버 필터 데이터 가공
export const setServerIdFilterData = (serverData: { [key: string]: string }[]) => {
  const filterData = FILTER_DATA[SERVICE_ALIAS.AION][ALIAS.CHARACTER];
  let newServerIdData = [...filterData[SEARCH_PARAMS.SERVER_ID]] as l10nFilterType;

  if (Array.isArray(serverData) && Array.isArray(newServerIdData)) {
    serverData?.forEach((v) => {
      const { serverName, serverId, world } = v || {};
      newServerIdData?.push({
        title: serverName,
        value: serverId,
        world: world?.toLowerCase() || '',
      });
    });
  }

  return newServerIdData;
};

// 직업 필터 데이터 가공
export const setClassIdFilterData = (classData: { [key: string]: string | number }[], isAllClassNameMap = false) => {
  const filterData = FILTER_DATA[SERVICE_ALIAS.AION][ALIAS.CHARACTER];
  let newClassIdData = [...filterData[SEARCH_PARAMS.CLASS_ID]] as l10nFilterType;

  if (Array.isArray(classData) && Array.isArray(newClassIdData)) {
    classData.forEach((v) => {
      if (v.jobName && v.jobId >= 0) {
        newClassIdData.push({
          title: v.jobName,
          value: isAllClassNameMap ? `${v.jobId}-${v.world.toLowerCase()}` : `${v.jobId}`,
        });
      }
    });
  }
  return newClassIdData;
};

// 월드 별 클래스
export const getWorldClassNameMap = (world = 'LIVE', classNameMap: { [key: string]: string | number }[]) => {
  const data = classNameMap?.filter((v) => v.world === world) || [];
  return data.map((v) => ({ ...v, world: v?.world?.toLowerCase() }));
};

/*
  직업데이터 Map으로 가공
  type jobId = string; // '0', '1', ...
  type worldType = 'live'| 'classic';
  new Map({
    [key: jobId]: {
      isSame: boolean; // 각 서버에서 jobId, jobName이 동일한 데이터인지 여부
      world: worldType[]; // 해당 jobId 데이터가 존재하는 서버명을 array에 넣어줌
      live?: {jobId: number, jobName: string, world: string}; // live 데이터
      classic?: {jobId: number, jobName: string, world: string}; // classic 데이터
    } 
  })
*/
export const setClassMapStatus = (worldType: string[], allClassNameMap: { [key: string]: string }[]) => {
  if (!Array.isArray(worldType) || !Array.isArray(allClassNameMap) || allClassNameMap.length === 0) {
    return {};
  }

  let classMapStatus = new Map();

  allClassNameMap.forEach((v) => {
    const key = `${v.jobId}`;
    const value = classMapStatus.get(key) || {};
    value.world = Array.isArray(value.world) ? value.world : [];

    if (v.world === '') {
      // 각 서버에 동일한 jobId, jobName을 가진 데이터
      value.isSame = true;
      worldType.forEach((world) => {
        value.world.push(world);
        value[world] = Object.assign({}, v, {
          world,
        });
      });
    } else {
      value.isSame = false;
      value.world.push(v.world);
      value[v.world] = v;
    }

    classMapStatus.set(key, value);
  });

  return classMapStatus;
};
